export const VARIANCE_SUPPORTING_DATA_EMAIL_TEMPLATE_KEY = 'VarianceSupportingDataEmail';

/** Must match server template `cid:` and API `ContentId`. */
export const VARIANCE_STATUS_ICON_CONTENT_ID = 'variance-status-icon';

export const EMAIL_INLINE_MEDIA_TYPES = {
  png: 'image/png',
  jpeg: 'image/jpeg',
  svgXml: 'image/svg+xml',
  webp: 'image/webp',
  gif: 'image/gif',
} as const;

/** Use with `chartDataUrlsToInlineAttachments` once the email HTML references these CIDs. */
export const EMAIL_ANALYTICS_CHART_CONTENT_ID_PREFIX = 'email-analytics';

export function emailAnalyticsChartContentId(chartKey: string): string {
  return `${EMAIL_ANALYTICS_CHART_CONTENT_ID_PREFIX}-${chartKey}`;
}

export function cidImageSrc(contentId: string): string {
  return `cid:${contentId.trim()}`;
}
